module.exports = __webpack_public_path__ + "img/teaser_training2.2b54642a.jpg";